import axios from 'axios';
import session from "../../utils/session";

const baseUrl =  process.env.REACT_APP_API_URL;
const isLocal = process.env.REACT_APP_LOCAL;

export const header = () => {
  return {
      Authorization: `Bearer ${session.getToken()}`,      
  }
};

export const headerWithLocal = () => {
  let h = header();
  if (isLocal == "1") {
    h['x-local'] = 1;
  }

  return h;
};


// 'Content-Type': 'application/x-www-form-urlencoded',

//Arreglar header
export const apiCall = async (url, data, headers, method) => {
  try {
    // timeout debe ir en la config de axios, no dentro de headers (antes iba mal y no aplicaba).
    // confirm_upload encadena panel→S3→resize y puede tardar >10s; sin margen el cliente corta antes que el servidor.
    const timeoutMs = url.includes('/uploads/confirm') ? 120000 : 60000;

    const res = await axios({
      method,
      url: baseUrl + url,
      data,
      headers: headers ? headers : header(),
      timeout: timeoutMs,
    });
    return res;

  } catch (err) {
    return err.response;
  }
} 

function _getNewToken() {
    return new Promise((resolve, reject) => {
 
      const config = {
        headers: header()
      }

      axios
        .patch(`${baseUrl}/api/auth/refresh`, null, config)
        .then(response => {
          // localStorage.setItem('userToken', response.data.data.token);
          session.setToken(response.data.data.token);
          resolve(response.data.data.token);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }


  axios.interceptors.response.use( (response) => {
    // Return a successful response back to the calling service
    return response;
  }, (error) => {
    // Return any error which is not due to authentication back to the calling service
    if (!error.response || error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    // Return any error which is due to authentication back to the calling service

    if (error.config.url.endsWith('/auth/login')) {

      if (error.response.status === 401) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }

    }

    // Si el request que devolvió 401 es el PROPIO refresh, la sesión está
    // vencida y no es recuperable: cerrar sesión en vez de re-refrescar.
    // Evita el loop infinito de PATCH /auth/refresh (storm de requests).
    if (error.config.url.endsWith('/auth/refresh')) {
      session.logout();
      window.location.href = '/login';
      return Promise.reject(error);
    }

    // Try request again with new token
    return _getNewToken()
      .then((token) => {
        // New request with new token
        const config = error.config;
        config.headers['Authorization'] = `Bearer ${token}`;
        return new Promise((resolve, reject) => {
          axios.request(config).then(response => {
            resolve(response);
          }).catch((error) => {
            reject(error);
          })
        });
  
      })
      .catch((error) => {

        // Si falló el refresh del token (por cualquier status), la sesión no
        // es recuperable: cerrar sesión y redirigir al login.
        if (error.config && error.config.url.endsWith('/auth/refresh')) {
          console.log('Sesión vencida');
          session.logout();
          window.location.href = '/login';
          return Promise.reject(error);
        }

        if (error.response) {
          console.log('ERROR', error.response.data && error.response.data.message);
        } else {
          console.log('ERROR sin response', error.message);
        }
        return Promise.reject(error);
      });
  });
